export enum PropertiesTranslationKey {
    ADD_PROPERTY = "properties.addProperty",
    DELETE_PROPERTY_PROMPT = "properties.deletePropertyPrompt",
    EDIT_PROPERTY_VALUE = "properties.editPropertyValue",
    NAME = "properties.name",
    NEW_PROPERTY = "properties.newProperty",
    PROPERTIES = "properties.properties",
    PROPERTY_CREATED_SUCCESSFULLY = "properties.propertyCreatedSuccessfully",
    PROPERTY_DELETED_SUCCESSFULLY = "properties.propertyDeletedSuccessfully",
    PROPERTY_UPDATED_SUCCESSFULLY = "properties.propertyUpdatedSuccessfully",
    PROPERTY_WILL_BE_DELETED = "properties.propertyWillBeDeleted",
    TYPE = "properties.type",
    UPDATE_PROPERTY = "properties.updateProperty",
    VALUE = "properties.value",
}